import { useCallback, useEffect, useState } from 'react';
import {
  addArticleToDataroom,
  loadDataroom,
  removeArticleFromDataroom,
  subscribeDataroom,
  type DataroomArticle,
  type DataroomState,
} from '../state/dataroomStore';

export function useDataroom() {
  const [state, setState] = useState<DataroomState>(() => loadDataroom());

  useEffect(() => {
    const refresh = () => setState(loadDataroom());
    refresh();
    return subscribeDataroom(refresh);
  }, []);

  const addArticle = useCallback((article: DataroomArticle) => {
    addArticleToDataroom(article);
  }, []);

  const removeArticle = useCallback((articleId: number) => {
    removeArticleFromDataroom(articleId);
  }, []);

  return { articles: state.articles, addArticle, removeArticle };
}
